import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome';
import {
    Button, Checkbox, ControlLabel, Form, FormControl, FormGroup, HelpBlock, OverlayTrigger,
    Radio, Tooltip
} from "react-bootstrap";
import { withRouter } from "react-router-dom";

import Loading from "../../components/Loading/index";
import TagInput from "../../components/TagInput/index";
import { getQuestion } from '../../redux/actions/questionActions';

class QuestionForm extends React.Component {
    static initForm(data) {
        return ({
            inProcess: false,
            values: {
                text: data ? data.text : '',
                explanation: data ? data.explanation : '',
                paragraph: data ? data.paragraph : '',
                lawLink: data ? data.lawLink : '',
                difficulty: data ? data.difficulty : 0,
                timeframe: data ? data.timeframe : 0,
                pointsValue: data ? data.pointsValue : 0,
                moneyValue: data ? data.moneyValue : 0,
                tagIds: data ? data.tagIds : [],
                questionType: data ? data.questionType : [],
                enabled: data ? data.enabled : true,
                answers: data ? data.answers : [],
                answersToDelete: [],
            },
            validation: {
                states: {
                    text: null,
                    explanation: null,
                    paragraph: null,
                    timeframe: null,
                    pointsValue: null,
                    moneyValue: null,
                    questionType: null,
                    answers: data && data.answers ? data.answers.map(() => ({ text: null })) : [],
                    answerMessage: null
                },
                messages: {
                    text: '',
                    explanation: '',
                    paragraph: '',
                    timeframe: '',
                    pointsValue: '',
                    moneyValue: '',
                    questionType: '',
                    answers: data && data.answers ? data.answers.map(() => ({ text: '' })) : [],
                    answerMessage: ''
                }
            },
        });
    }

    constructor(props) {
        super(props);

        this.state = QuestionForm.initForm(props.question);

        // handles for questions
        this.handleChangeText = this.handleChangeText.bind(this);
        this.handleChangeExplanation = this.handleChangeExplanation.bind(this);
        this.handleChangeParagraph = this.handleChangeParagraph.bind(this);
        this.handleChangeLawLink = this.handleChangeLawLink.bind(this);
        this.handleChangeTimeframe = this.handleChangeTimeframe.bind(this);
        this.handleChangePointsValue = this.handleChangePointsValue.bind(this);
        this.handleChangeMoneyValue = this.handleChangeMoneyValue.bind(this);
        this.handleChangeQuestionType = this.handleChangeQuestionType.bind(this);
        this.handleChangeEnabled = this.handleChangeEnabled.bind(this);
        this.handleChangeQuestionTags = this.handleChangeQuestionTags.bind(this);

        // handles for answers
        this.handleChangeAnswerText = this.handleChangeAnswerText.bind(this);
        this.handleChangeAnswerCorrectness = this.handleChangeAnswerCorrectness.bind(this);
        this.handleChangeAnswerEnabled = this.handleChangeAnswerEnabled.bind(this);
        this.handleAddAnswer = this.handleAddAnswer.bind(this);
        this.handleRemoveAnswer = this.handleRemoveAnswer.bind(this);

        // handle for form
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    componentDidMount() {
        const { match, sessionData, loading, question, fceGetQuestion } = this.props;
        const questionId = match.params.id;
        const token = sessionData ? sessionData.accessToken : null;
        if (token && questionId && !loading && (!question || !question.answers)) {
            fceGetQuestion(token, questionId);
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        const { match, sessionData, loading, question, fceGetQuestion } = nextProps;
        const questionId = match.params.id;
        const token = sessionData ? sessionData.accessToken : null;
        if (token && questionId && !loading && (!question || !question.answers)) {
            fceGetQuestion(token, questionId);
        }
        if (question && question.answers) {
            this.setState(QuestionForm.initForm(question));
        }
    }

    /* Handles */
    handleChangeText(event) {
        let value =  event ? event.target.value : this.state.values.text;

        let values = this.state.values;
        values.text = value;

        let validation = this.state.validation;
        validation.states.text = value === '' ? 'error' : 'success';
        validation.messages.text = value === '' ? 'Znění otázky nesmí být prázdné!' : '';

        this.setState({
            values,
            validation
        });
    }

    handleChangeExplanation(event) {
        let value =  event ? event.target.value : this.state.values.explanation;

        let values = this.state.values;
        values.explanation = value;

        let validation = this.state.validation;
        validation.states.explanation = value === '' ? 'error' : 'success';
        validation.messages.explanation = value === '' ? 'Vysvětlení nesmí být prázdné!' : '';

        this.setState({
            values,
            validation
        });
    }

    handleChangeParagraph(event) {
        let value =  event ? event.target.value : this.state.values.paragraph;

        let values = this.state.values;
        values.paragraph = value;

        let validation = this.state.validation;
        validation.states.paragraph = value === '' ? 'error' : 'success';
        validation.messages.paragraph = value === '' ? 'Paragraf nesmí být prázdný!' : '';

        this.setState({
            values,
            validation
        });
    }

    handleChangeLawLink(event) {
        let value =  event ? event.target.value : this.state.values.lawLink;

        let values = this.state.values;
        values.lawLink = value;

        this.setState({
            values
        });
    }

    handleChangeTimeframe(event) {
        let value =  event ? event.target.value : this.state.values.timeframe;

        let values = this.state.values;
        values.timeframe = value;

        let validation = this.state.validation;
        validation.states.timeframe = value === '' ? 'error' : 'success';
        validation.messages.timeframe = value === '' ? 'Časová náročnost nesmí být prázdná!' : '';

        this.setState({
            values,
            validation
        });
    }

    handleChangePointsValue(event) {
        let value =  event ? event.target.value : this.state.values.pointsValue;

        let values = this.state.values;
        values.pointsValue = value;

        let validation = this.state.validation;
        validation.states.pointsValue = value === '' ? 'error' : 'success';
        validation.messages.pointsValue = value === '' ? 'Hodnota v bodech nesmí být prázdná!' : '';

        this.setState({
            values,
            validation
        });
    }

    handleChangeMoneyValue(event) {
        let value =  event ? event.target.value : this.state.values.moneyValue;

        let values = this.state.values;
        values.moneyValue = value;

        let validation = this.state.validation;
        validation.states.moneyValue = value === '' ? 'error' : 'success';
        validation.messages.moneyValue = value === '' ? 'Hodnota v penězích nesmí být prázdná!' : '';

        this.setState({
            values,
            validation
        });
    }

    handleChangeQuestionType(type, checked) {
        let values = this.state.values;
        if (type) {
            if (checked) {
                let index = values.questionType.indexOf(type);
                if (index !== -1) {
                    values.questionType.splice(index, 1);
                }
            } else {
                values.questionType.push(type);
            }
        }

        let validation = this.state.validation;
        validation.states.questionType = values.questionType.length > 0 ? 'success': 'error';
        validation.messages.questionType = values.questionType.length > 0 ? '' : 'Typ otázky musí být vybrán!';

        this.setState({
            values,
            validation
        })
    }

    handleChangeEnabled() {
        let values = this.state.values;

        values.enabled = !values.enabled;

        this.setState({
           values
        });
    }

    handleChangeQuestionTags(tags) {
        let value = tags ? tags : this.state.values.tagIds;

        let values = this.state.values;
        values.tagIds = value.map(tag => tag.name);

        this.setState({
            values
        })
    }

    handleChangeAnswerText(event, index) {
        const text =  event ? event.target.value : this.state.values.answers[index].text;

        let values = this.state.values;
        values.answers[index].text = text;

        const validation = this.state.validation;
        validation.states.answers[index].text = text === '' ? 'error' : 'success';
        validation.messages.answers[index].text = text === '' ? 'Znění odpovědí nesmí být prázdné!' : '';

        this.setState({
            values,
            validation
        });
    }

    handleChangeAnswerCorrectness(e, index) {
        let correctness = e ? e.target.checked : this.state.values.answers[index].correctness;

        let values = this.state.values;

        if (e) {
            values.answers.map((answer) => {
                answer.correctness = false;
                return answer;
            });
            values.answers[index].correctness = correctness;
        }

        this.setState({
            values
        });
    }

    handleChangeAnswerEnabled(answer){
        axios.put(this.props.api.answers + "/" + answer.id, {
            enabled: !answer.enabled,
            access_token: this.props.accessToken
        })
        .then(() => {
            this.getAnswers();
        })
        .catch((error) => {
            console.log("Axios error: ", error);
        })
    }

    handleAddAnswer() {
        console.log('addAnswer', this);

        const newAnsw = {
            text: "",
            correctness: false
        };

        let values = this.state.values;
        values.answers.push(newAnsw);

        let validation = this.state.validation;
        validation.states.answers.push({text: null});
        validation.messages.answers.push({text: ''});

        this.setState({
            values,
            validation
        });

    }

    handleRemoveAnswer(index) {
        console.log('removeAnwer', index);
        let values = this.state.values;
        let answer = values.answers[index];

        if (answer.id) values.answersToDelete.push(answer);
        values.answers.splice(index, 1);

        let validation = this.state.validation;
        validation.states.answers.splice(index, 1);
        validation.messages.answers.splice(index, 1);

        this.setState({
            values,
            validation
        });
    }
    /* /Handles */

    /* Form functions */
    validateAnswers() {
        let valid = true;

        let answers = this.state.values.answers;
        let validation = this.state.validation;

        validation.states.answerMessage = null;
        validation.messages.answerMessage = '';

        if (answers.length > 0) {
            // provedení kontrol nad inputy
            answers.forEach((answer, answerIndex) => {
                this.handleChangeAnswerText(null, answerIndex);
            });

            // kontrola výběru správné odpovědi
            if (answers.map((answer) => answer.correctness).indexOf(true) === -1) {
                validation.messages.answerMessage = 'Otázka nemá vybranou správnou odpověď!';
                validation.states.answerMessage = 'error';
                valid = false;
            }

            // kontrola stavů odpovědí
            let answersStates = this.state.validation.states.answers;
            answersStates.forEach((answer) => {
                if (Object.values(answer).indexOf('error') >= 0) {
                    valid = false;
                }
            });
        } else {
            validation.messages.answerMessage = 'U otázky chybí odpovědi!';
            validation.states.answerMessage = 'error';
            valid = false;
        }

        return valid;
    }

    isValid () {
        this.handleChangeText();
        this.handleChangeExplanation();
        this.handleChangeTimeframe();
        this.handleChangePointsValue();
        this.handleChangeMoneyValue();
        this.handleChangeQuestionType();
        let validAnswers = this.validateAnswers();
        let valid = (Object.values(this.state.validation.states).indexOf('error') < 0);

        return valid && validAnswers;
    }

    handleSubmit(event) {
        event.preventDefault();
        const { match } = this.props;
        const questionId = match.params.id;
        if (this.isValid()){
            this.setState({inProcess: true});
            if (questionId) {
                this.props.action(questionId, this.state.values);
            } else {
                this.props.action(this.state.values);
            }
        }
    }

    handleClose() {
        this.props.history.push('/questions');
    }
    /* /Form functions */

    render() {
        const { loading } = this.props;
        const { validation, inProcess } = this.state;
        let { messages, states } = this.state.validation;
        let values = this.state.values;
        let answers = values.answers;
        let title = this.props.data ? this.props.title + " č. " + values.name : this.props.title;
        let dailyChallenge = values.questionType.indexOf("dailychallenge") !== -1;
        let testing = values.questionType.indexOf("testing") !== -1;
        let special = values.questionType.indexOf("special") !== -1;
        let educationMaterial = values.questionType.indexOf("educationmaterial") !== -1;
        let bonus = values.questionType.indexOf("bonus") !== -1;

        const formLoading = loading || inProcess;

        if (loading) return <Loading />;

        const tooltipEnable = (
            <Tooltip id="tooltip-enable">Zakázat odpověď</Tooltip>
        );
        const tooltipDisable = (
            <Tooltip id="tooltip-disable">Povolit odpověď</Tooltip>
        );
        const tooltipRemove = (
            <Tooltip id="tooltip-remove">Odebrat odpověď</Tooltip>
        );

        return (
            <div className="x-panel">
                <div className="x-title">
                    <h2>{title}</h2>
                    <div className="clearfix"/>
                </div>
                <div className="x-content">
                    {
                        this.state.loading ? <Loading/> :
                            <Form onSubmit={this.handleSubmit}>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <h4>Základní údaje</h4>
                                    <FormGroup controlId="text" validationState={states.text}>
                                        <ControlLabel>Znění otázky <span className="required">*</span></ControlLabel>
                                        <FormControl componentClass="textarea" value={values.text} placeholder="Zadejte znění otázky"
                                                     onChange={this.handleChangeText}/>
                                        <FormControl.Feedback/>
                                        <HelpBlock>{messages.text}</HelpBlock>
                                    </FormGroup>
                                    <FormGroup controlId="explanation" validationState={states.explanation}>
                                        <ControlLabel>Vysvětlení <span className="required">*</span></ControlLabel>
                                        <FormControl componentClass="textarea" value={values.explanation} placeholder="Zadejte vysvětlení otázky"
                                                     onChange={this.handleChangeExplanation}/>
                                        <FormControl.Feedback/>
                                        <HelpBlock>{messages.explanation}</HelpBlock>
                                    </FormGroup>
                                    <FormGroup controlId="paragraph" validationState={states.paragraph}>
                                        <ControlLabel>Paragraf <span className="required">*</span></ControlLabel>
                                        <FormControl type="text" value={values.paragraph} placeholder="Zadejte paragraf"
                                                     onChange={this.handleChangeParagraph}/>
                                        <FormControl.Feedback/>
                                        <HelpBlock>{messages.timeframe}</HelpBlock>
                                    </FormGroup>
                                    <FormGroup controlId="lawLink">
                                        <ControlLabel>Odkaz na zákon</ControlLabel>
                                        <FormControl type="text" value={values.lawLink} placeholder="Zadejte odkaz na zákon"
                                                     onChange={this.handleChangeLawLink}/>
                                    </FormGroup>
                                    <FormGroup controlId="timeframe" validationState={states.timeframe}>
                                        <ControlLabel>Časová náročnost <span
                                            className="required">*</span></ControlLabel>
                                        <FormControl type="number" value={values.timeframe} min="0" placeholder="Zadejte časovou náročnost"
                                                     onChange={this.handleChangeTimeframe}/>
                                        <FormControl.Feedback/>
                                        <HelpBlock>{messages.timeframe}</HelpBlock>
                                    </FormGroup>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <h4>Hodnocení</h4>
                                    <FormGroup controlId="pointsValue" validationState={states.pointsValue}>
                                        <ControlLabel>Hodnota v bodech <span
                                            className="required">*</span></ControlLabel>
                                        <FormControl type="number" value={values.pointsValue} min="0" placeholder="Zadejte hodnotu v bodech"
                                                     onChange={this.handleChangePointsValue}/>
                                        <FormControl.Feedback/>
                                        <HelpBlock>{messages.pointsValue}</HelpBlock>
                                    </FormGroup>
                                    <FormGroup controlId="moneyValue" validationState={states.moneyValue}>
                                        <ControlLabel>Hodnota v penězích <span
                                            className="required">*</span></ControlLabel>
                                        <FormControl type="number" value={values.moneyValue} min="0" placeholder="Zadejte hodnotu v penězích"
                                                     onChange={this.handleChangeMoneyValue}/>
                                        <FormControl.Feedback/>
                                        <HelpBlock>{messages.moneyValue}</HelpBlock>
                                    </FormGroup>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <h4>Typ otázky</h4>
                                    <FormGroup controlId="questionType" validationState={states.questionType}>
                                        <Checkbox inline checked={dailyChallenge}
                                                  onChange={() => this.handleChangeQuestionType('dailychallenge', dailyChallenge)}>
                                            Denní výzva
                                        </Checkbox>
                                        {' '}
                                        <Checkbox inline checked={testing}
                                                  onChange={() => this.handleChangeQuestionType('testing', testing)}>
                                            Test
                                        </Checkbox>
                                        {' '}
                                        <Checkbox inline checked={special}
                                                  onChange={() => this.handleChangeQuestionType('special', special)}>
                                            Speciál
                                        </Checkbox>
                                        {' '}
                                        <Checkbox inline checked={educationMaterial}
                                                  onChange={() => this.handleChangeQuestionType('educationMaterial', educationMaterial)}>
                                            Vzdělávací materiál
                                        </Checkbox>
                                        {' '}
                                        <Checkbox inline checked={bonus}
                                                  onChange={() => this.handleChangeQuestionType('bonus', bonus)}>
                                            Bonus
                                        </Checkbox>
                                        <HelpBlock>{messages.questionType}</HelpBlock>
                                    </FormGroup>
                                    <h4>Zakázání otázky</h4>
                                    <FormGroup>
                                        <Checkbox inline checked={!values.enabled}
                                                  onChange={this.handleChangeEnabled}>
                                            Zakázat otázku
                                        </Checkbox>
                                    </FormGroup>
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <h4>Tagy</h4>
                                    <TagInput
                                        api={this.props.api}
                                        accessToken={this.props.accessToken}
                                        tags={values.tagIds}
                                        handleChangeQuestionTags={this.handleChangeQuestionTags}
                                    />
                                </div>
                                <div className="clearfix"/>
                                <div className="ln-solid"/>
                                <div
                                    className="col-lg-offset-3 col-md-offset-3 col-sm-offset-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <h4>Odpovědi</h4>
                                    <table className="table">
                                        <thead>
                                        <tr>
                                            <th>Znění <span className="required">*</span></th>
                                            <th>Správná odpověď</th>
                                            <th/>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            answers && answers.map((answer, index) => {
                                                    let answerStates = states.answers[index];
                                                    let answerMessages = messages.answers[index];
                                                    let style = answer.state === 'delete' ? {display: 'none'} : {display: 'table-row'};
                                                    return (
                                                        <tr key={index} style={style}>
                                                            <td>
                                                                <FormGroup controlId="answerText"
                                                                           validationState={answerStates.text}>
                                                                    <FormControl type="text" value={answer.text} placeholder="Zadejte znění odpovědi"
                                                                                 onChange={(event) => this.handleChangeAnswerText(event, index)}/>
                                                                    <FormControl.Feedback/>
                                                                    <HelpBlock>{answerMessages.text}</HelpBlock>
                                                                </FormGroup>
                                                            </td>
                                                            <td>
                                                                <Radio checked={answer.correctness}
                                                                       onChange={(event) => this.handleChangeAnswerCorrectness(event, index)}/>
                                                            </td>
                                                            <td>
                                                                {
                                                                    answer.enabled && answer.state === 'edit' &&
                                                                    <OverlayTrigger placement="top" overlay={tooltipEnable}>
                                                                        <FontAwesome name="unlock" size="2x"
                                                                                     onClick={() => this.handleChangeAnswerEnabled(answer)}
                                                                                     className="cursor-p"/>
                                                                    </OverlayTrigger>
                                                                }
                                                                {
                                                                    !answer.enabled && answer.state === 'edit' &&
                                                                    <OverlayTrigger placement="top"
                                                                                    overlay={tooltipDisable}>
                                                                        <FontAwesome name="lock" size="2x"
                                                                                     onClick={() => this.handleChangeAnswerEnabled(answer)}
                                                                                     className="cursor-p"/>
                                                                    </OverlayTrigger>
                                                                }
                                                                {' '}
                                                                {
                                                                    !answer.used &&
                                                                    <OverlayTrigger placement="top" overlay={tooltipRemove}>
                                                                        <FontAwesome name="trash" size="2x"
                                                                                     className="cursor-p"
                                                                                     onClick={() => this.handleRemoveAnswer(index)}
                                                                        />
                                                                    </OverlayTrigger>
                                                                }
                                                            </td>
                                                        </tr>
                                                    );
                                                }
                                            )}
                                        </tbody>
                                    </table>
                                    <Button type="button" className="btn btn-success"
                                            onClick={() => this.handleAddAnswer()}>
                                        Přidat odpověď
                                    </Button>
                                    <FormGroup validationState={states.answerMessage}>
                                        <HelpBlock>{messages.answerMessage}</HelpBlock>
                                    </FormGroup>
                                </div>
                                <div className="clearfix"/>
                                <div className="ln-solid"/>
                                <FormGroup>
                                    <div className="col-md-4 col-sm-4 col-xs-12 col-md-offset-4">
                                        <Button className="btn-primary" type="button"
                                                onClick={this.handleClose}>Zpět</Button>
                                        <Button type="submit" disabled={formLoading}
                                                className="btn btn-success">{this.props.button}</Button>
                                        {formLoading && <Loading/>}
                                    </div>
                                </FormGroup>
                            </Form>
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const questionId = ownProps.match.params.id;
    return {
        loading: state.questions.loading,
        question: questionId && state.questions.items ? state.questions.items[questionId] : null
    }
};

const mapDispatchToProps = (dispatch) => ({
    fceGetQuestion: (token, questionId, callback) => dispatch(getQuestion(token, questionId)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QuestionForm));



/** WEBPACK FOOTER **
 ** ./src/containers/Questions/QuestionForm.js
 **/